var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M14 15c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1s.448-1 1-1h3c.552 0 1 .448 1 1zm0-3c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1s.448-1 1-1h3c.552 0 1 .448 1 1zm0-3c0 .552-.448 1-1 1h-3c-.552 0-1-.448-1-1s.448-1 1-1h3c.552 0 1 .448 1 1zm-6 6c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm0-3c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm0-3c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1zm7 8c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V4.5c0-.276.224-.5.5-.5H6c0 1.104.895 2 2 2h4c1.105 0 2-.896 2-2h.5c.276 0 .5.224.5.5V17zM8 3c0-.552.448-1 1-1h2c.552 0 1 .448 1 1s-.448 1-1 1H9c-.552 0-1-.448-1-1zm7-1h-1c0-1.105-.895-2-2-2H8C6.895 0 6 .895 6 2H5c-1.105 0-2 .895-2 2v14c0 1.104.895 2 2 2h10c1.105 0 2-.896 2-2V4c0-1.105-.895-2-2-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillOpacity: 0,
    xlinkHref: "#prefix__a"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.d42e6b8ff459095d5b64bdb282462277.svg";
export { ForwardRef as ReactComponent };